export const ChangePathName=(pathName)=>{
    let firstReplace=pathName.replace(/[[]+/g,'.');
    return firstReplace.replace(/[\]']+/g,'');
};